import React, { useEffect, useRef } from 'react';

import { isCcpaBannerVariantActive } from '../consent-manager/flags';
import './banner.scss';

import { isUrlPricingPage } from '../welcome';
import Icon from '@wetransfer/transfer/component/icon';
import { clickLinkCcpaBanner } from '@wetransfer/transfer/modules/consent-manager/tracker';
import I18n from '@wetransfer/transfer/modules/i18n';

const CloseIcon = (): JSX.Element => (
  <Icon type={'Cross'} hoverColor={'#fff'} />
);

export interface Props {
  closeBanner(): void;
}

export default function Banner({ closeBanner }: Props): JSX.Element {
  const element = useRef(null);
  const legalPageHref = '/legal/ccpa';
  const ccpaVariantLink = '/legal/manage-cookies ';

  const content = {
    text: {
      __html: I18n.t('transfer.consent-manager.ccpa-banner-text', {
        href: legalPageHref,
      }),
    },
  };

  const variant = {
    text: {
      __html: I18n.t('transfer.consent-manager.ccpa-variant-test-text', {
        href: ccpaVariantLink,
      }),
    },
  };

  useEffect(() => {
    // eslint-disable-next-line no-undef
    const legalLinks: NodeListOf<HTMLElement> =
      element.current.querySelectorAll(`a[href="${legalPageHref}"]`);

    if (legalLinks) {
      Array.from(legalLinks).forEach((legalLink) => {
        legalLink.onclick = clickLinkCcpaBanner;
      });
    }
  }, [element]);

  return (
    <>
      {isCcpaBannerVariantActive() && isUrlPricingPage() ? (
        <div className={'banner__container banner__variant'}>
          <div className={'banner'} ref={element}>
            <div
              className={'banner__text'}
              dangerouslySetInnerHTML={variant.text}
            />
          </div>
          <button onClick={closeBanner} className={'banner__close'}>
            <CloseIcon />
          </button>
        </div>
      ) : (
        <div className={'banner__container'}>
          <div className={'banner'} ref={element}>
            <div
              className={'banner__text'}
              dangerouslySetInnerHTML={content.text}
            />
          </div>
          <button onClick={closeBanner} className={'banner__close'}>
            <CloseIcon />
          </button>
        </div>
      )}
    </>
  );
}
